var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"my-2"},[_c('v-card-title',[_vm._v(_vm._s(_vm.message.role))]),_c('v-card-text',[_vm._v(_vm._s(_vm.message.full_text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }